var _sodipodiNamedview, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChurch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 31.75 31.750002",
    id: "svg1696",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "church.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1698",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    "inkscapeDocument-units": "px",
    showgrid: "false",
    inkscapeZoom: 2.1997092,
    inkscapeCx: 39.32338,
    inkscapeCy: 58.416813,
    "inkscapeWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1-0",
    units: "px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1693"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Ebene 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    style: {},
    transform: "translate(-0.03787441,-0.00135587)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1-0",
    transform: "matrix(0.08824396,0,0,0.08824396,-15.407258,-25.410811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6",
    transform: "matrix(0.65850942,0,0,0.65850942,187.56605,298.71255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 477.42,340.613 -1.419,-0.467 c -10e-4,0 -0.002,-0.001 -0.003,-0.001 L 359.211,301.697 V 163.76 c 0,-2.95 -1.26,-5.598 -3.261,-7.46 -0.032,-0.033 -0.054,-0.065 -0.091,-0.098 L 265.94,74.728 V 44.102 h 14.021 c 5.633,0 10.199,-4.566 10.199,-10.199 0,-5.633 -4.566,-10.199 -10.199,-10.199 H 265.94 V 10.199 C 265.941,4.566 261.375,0 255.742,0 250.109,0 245.543,4.566 245.543,10.199 v 13.505 h -14.02 c -5.633,0 -10.199,4.566 -10.199,10.199 0,5.633 4.566,10.199 10.199,10.199 h 14.02 v 30.632 l -89.721,81.475 c -0.022,0.02 -0.031,0.041 -0.05,0.061 -2.019,1.863 -3.292,4.524 -3.292,7.489 V 301.701 L 36,340.143 c -0.002,0.001 -0.005,0.001 -0.007,0.002 l -1.419,0.468 c -4.18,1.38 -7.004,5.284 -7.004,9.686 v 151.5 c 0,5.633 4.566,10.199 10.199,10.199 h 436.464 c 5.633,0 10.199,-4.566 10.199,-10.199 v -151.5 c -0.001,-4.402 -2.828,-8.309 -7.012,-9.686 z M 152.479,491.602 H 47.966 v -131.57 h 104.512 v 131.57 z m 0,-151.969 h -49.846 l 49.846,-16.45 z M 255.75,93.02 322.566,153.562 H 189.08 Z m 41.763,398.582 h -83.337 v -50.933 c 0,-22.61 15.866,-41.005 35.368,-41.005 h 12.601 c 19.502,0 35.368,18.395 35.368,41.005 z m 41.3,0 h -20.901 v -50.933 c 0,-33.858 -25.017,-61.403 -55.766,-61.403 h -12.601 c -30.75,0 -55.766,27.545 -55.766,61.403 v 50.933 H 172.878 V 349.833 173.96 h 165.936 v 317.642 z m 20.398,-168.43 50.002,16.462 h -50.002 z m 104.822,168.43 H 359.211 v -131.57 h 104.821 v 131.57 z",
    id: "path2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(0.65850942,0,0,0.65850942,187.56605,298.71255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 255.742,214.367 c -14.614,0 -26.505,11.89 -26.505,26.505 V 313.2 c 0,5.632 4.566,10.199 10.199,10.199 h 32.61 c 5.633,0 10.199,-4.566 10.199,-10.199 v -72.328 c 10e-4,-14.615 -11.888,-26.505 -26.503,-26.505 z M 261.848,303 h -12.212 v -62.128 c 0,-3.367 2.74,-6.106 6.106,-6.106 3.367,0 6.105,2.74 6.105,6.106 V 303 Z",
    id: "path8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "matrix(0.65850942,0,0,0.65850942,187.56605,298.71255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 390.752,463.775 h -2.061 c -5.633,0 -10.199,4.566 -10.199,10.199 0,5.633 4.566,10.199 10.199,10.199 h 2.061 c 5.633,0 10.199,-4.566 10.199,-10.199 10e-4,-5.633 -4.566,-10.199 -10.199,-10.199 z",
    id: "path14"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "matrix(0.65850942,0,0,0.65850942,187.56605,298.71255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 446.404,463.775 H 422.7 c -5.633,0 -10.199,4.566 -10.199,10.199 0,5.633 4.566,10.199 10.199,10.199 h 23.704 c 5.633,0 10.199,-4.566 10.199,-10.199 10e-4,-5.633 -4.566,-10.199 -10.199,-10.199 z",
    id: "path20"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch);
export default __webpack_public_path__ + "static/media/church.aaab267d1ead58bffe961e2f8dacf4fb.svg";
export { ForwardRef as ReactComponent };